export const ITEM_GROUP_ORDER = [
  'Smartphone',
  'Tablet',
  'Smartwatch',
  'Notebook',
  'Zubehör',
];
